import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen text-white"
      style={{
        backgroundImage: "url(/bg12.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="text-white p-4 flex justify-between items-">
        <button
          onClick={() => navigate('/app')} 
          className="text-white"
        >
          <img
            src="https://img.icons8.com/?size=100&id=40217&format=png&color=FFFFFF"
            alt="back"
            className="w-6 h-6"
          />
        </button>
        <div className="text-center">
          <h1 className="text-3xl font-bold cursor-pointer" onClick={()=>navigate('/app')}>GemX</h1>
        </div>
        <div className="flex items-center">
        </div>
      </div>
      <div className="p-8">
        <h2 className="text-2xl font-bold mb-4">Your Privacy Matters at GemX</h2>
        <p className="mb-2">
          At GemX, we understand the importance of protecting your privacy. We collect
          information to personalize your experience and continually improve the capabilities
          of GemX. This information may include voice recordings during calls, chat transcripts,
          and search queries you make while using voice or chat features.
        </p>
        <p className="mb-2">
          We want to be transparent about how we use your data. Here's a breakdown:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>
            <strong>Personalization:</strong> The information we collect helps GemX learn your
            preferences, understand your needs better, and provide more relevant responses during
            calls, chats, and other interactions.
          </li>
          <li>
            <strong>Improvement:</strong> By analyzing usage data, we can identify areas for
            improvement and make GemX a smarter, more helpful AI assistant.
          </li>
          <li>
            <strong>Security:</strong> Your data is never shared with third parties without your
            explicit consent. We implement industry-leading security measures to safeguard your
            information and prevent unauthorized access.
          </li>
        </ul>
        <h3 className="text-2xl font-bold mb-2">Control Over Your Data</h3>
        <p className="mb-2">
          We believe you should have control over your data. Here's how GemX empowers you:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>
            <strong>Access and Review:</strong> You can access and review your data, including
            voice recordings and chat transcripts, at any time within the app settings.
          </li>
          <li>
            <strong>Deletion:</strong> You have the right to request the deletion of your data. We
            will process your request promptly in accordance with applicable laws and regulations.
          </li>
        </ul>
        <h3 className="text-2xl font-bold mb-2">Transparency and Further Information</h3>
        <p className="mb-2">
          We strive to be transparent about our data practices. For a more comprehensive
          explanation of how we collect, use, and protect your information, please refer to our
          full Privacy Policy available within the app. This policy details the specific types of
          data we collect, the purposes for which it's used, and your rights regarding your data.
        </p>
        <p className="mb-2">
          By using GemX, you agree to our Privacy Policy.
        </p>
        <p className="mb-2">
          This extended version provides more detailed information about the types of data
          collected, its purpose, and your rights regarding access and deletion. It also
          emphasizes GemX's commitment to transparency and user control.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
